/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Atomica() {
  return (
    <PaginasEspecificas posicao="20" endereco="/fisica" materia="Física" />
  );
}

export default Atomica;
